var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time-counter"},[_vm._v(_vm._s(_vm.day)+"天"+_vm._s(_vm.hr)+"时"+_vm._s(_vm.min)+"分"+_vm._s(_vm.sec)+"秒")])}
var staticRenderFns = []

export { render, staticRenderFns }